export default __webpack_public_path__ + "static/media/P948_RoHS.abdd684d.pdf";